import { defineMessages } from 'react-intl';

export const allowListMessages = defineMessages({
    addWhiteListSubtitle: {
        id: 'add-white-list-subtitle',
        defaultMessage: 'Add new white list',
    },
    editWhiteListSubtitle: {
        id: 'edit-white-list-subtitle',
        defaultMessage: 'Edit white list {entry}',
    },
    deleteWhiteListSubtitle: {
        id: 'delete-white-list-subtitle',
        defaultMessage: 'Permanently delete white list {entry}',
    },
    confirmDeleteWhiteList: {
        id: 'confirm-delete-white-list',
        defaultMessage: 'Are you sure you want to delete white list {entry}? This action cannot be undone.',
    },
    createWhiteListSuccess: {
        id: 'create-white-list-success',
        defaultMessage: 'White list created',
    },
    updateWhiteListSuccess: {
        id: 'update-white-list-success',
        defaultMessage: 'White list updated',
    },
    deleteWhiteListSuccess: {
        id: 'delete-white-list-success',
        defaultMessage: 'White list deleted',
    },
    createWhiteListSuccessDescription: {
        id: 'create-white-list-success-description',
        defaultMessage: 'White list {entry} has been successfully created.',
    },
    updateWhiteListSuccessDescription: {
        id: 'update-white-list-success-description',
        defaultMessage: 'White list {entry} has been successfully updated.',
    },
    deleteWhiteListSuccessDescription: {
        id: 'delete-white-list-success-description',
        defaultMessage: 'White list {entry} has been successfully deleted.',
    },
    addAllowListItemSubtitle: {
        id: 'add-allow-list-item-subtitle',
        defaultMessage: 'Add new allow list item',
    },
    editAllowListItemSubtitle: {
        id: 'edit-allow-list-item-subtitle',
        defaultMessage: 'Edit allow list item {entry}',
    },
    deleteAllowListItemSubtitle: {
        id: 'delete-allow-list-item-subtitle',
        defaultMessage: 'Permanently delete allow list item {entry}',
    },
    confirmDeleteAllowListItem: {
        id: 'confirm-delete-allow-list-item',
        defaultMessage: 'Are you sure you want to delete allow list item {entry}? This action cannot be undone.',
    },
    createAllowListItemSuccess: {
        id: 'create-allow-list-item-success',
        defaultMessage: 'Allow list item created',
    },
    updateAllowListItemSuccess: {
        id: 'update-allow-list-item-success',
        defaultMessage: 'Allow list item updated',
    },
    deleteAllowListItemSuccess: {
        id: 'delete-allow-list-item-success',
        defaultMessage: 'Allow list item deleted',
    },
    createAllowListItemSuccessDescription: {
        id: 'create-allow-list-item-success-description',
        defaultMessage: 'Allow list item {entry} has been successfully created.',
    },
    updateAllowListItemSuccessDescription: {
        id: 'update-allow-list-item-success-description',
        defaultMessage: 'Allow list item {entry} has been successfully updated.',
    },
    deleteAllowListItemSuccessDescription: {
        id: 'delete-allow-list-item-success-description',
        defaultMessage: 'Allow list item {entry} has been successfully deleted.',
    },

    addBlackListSubtitle: {
        id: 'add-black-list-subtitle',
        defaultMessage: 'Add new black list',
    },
    editBlackListSubtitle: {
        id: 'edit-black-list-subtitle',
        defaultMessage: 'Edit black list {entry}',
    },
    deleteBlackListSubtitle: {
        id: 'delete-black-list-subtitle',
        defaultMessage: 'Permanently delete black list {entry}',
    },
    confirmDeleteBlackList: {
        id: 'confirm-delete-black-list',
        defaultMessage: 'Are you sure you want to delete black list {entry}? This action cannot be undone.',
    },
    createBlackListSuccess: {
        id: 'create-black-list-success',
        defaultMessage: 'Black list created',
    },
    updateBlackListSuccess: {
        id: 'update-black-list-success',
        defaultMessage: 'Black list updated',
    },
    deleteBlackListSuccess: {
        id: 'delete-black-list-success',
        defaultMessage: 'Black list deleted',
    },
    createBlackListSuccessDescription: {
        id: 'create-black-list-success-description',
        defaultMessage: 'Black list {entry} has been successfully created.',
    },
    updateBlackListSuccessDescription: {
        id: 'update-black-list-success-description',
        defaultMessage: 'Black list {entry} has been successfully updated.',
    },
    deleteBlackListSuccessDescription: {
        id: 'delete-black-list-success-description',
        defaultMessage: 'Black list {entry} has been successfully deleted.',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    blackList: {
        id: 'black-list',
        defaultMessage: 'Black list',
    },
    blackLists: {
        id: 'black-lists',
        defaultMessage: 'Black lists',
    },
    whiteList: {
        id: 'white-list',
        defaultMessage: 'White list',
    },
    whiteLists: {
        id: 'white-lists',
        defaultMessage: 'White lists',
    },
    zones: {
        id: 'zones',
        defaultMessage: 'Zones',
    },
    gateways: {
        id: 'gateways',
        defaultMessage: 'Gateways',
    },
    total: {
        id: 'total',
        defaultMessage: 'Total',
    },
    allowListItem: {
        id: 'allow-list-item',
        defaultMessage: 'Allow list item',
    },
    allowListItems: {
        id: 'allow-list-items',
        defaultMessage: 'Allow list items',
    },
    deleteList: {
        id: 'delete-list',
        defaultMessage: 'Delete list',
    },
    listDashboard: {
        id: 'list-dashboard',
        defaultMessage: 'List dashboard',
    },
});
